import { useTranslation } from '@crehana/i18n';
import { Col, Container, Row } from '@crehana/ui';

import { BottomOpacity, StyledH2, StyledSection } from './Companies.styles';
import { COMPANIES_ROW1, COMPANIES_ROW2, COMPANIES_ROW3 } from './constants';
import CompaniesRow from './CompaniesRow';

const Companies: React.FC = () => {
  const { t } = useTranslation();

  return (
    <StyledSection className="overflow-hidden bg-gray-lighter pt-64 pb-32 relative lg:mt-120 z-6">
      <Container full>
        <Row>
          <Col className="pb-32">
            <StyledH2 className="font-h2 text-center mx-20 text-32 leading-40 sm:mx-auto md:text-52 md:leading-64">
              <span className="text-primary-main">{t('COMPANIES_TITLE1')}</span>{' '}
              {t('COMPANIES_TITLE2')}
            </StyledH2>
            <CompaniesRow
              companies={COMPANIES_ROW1}
              size={{ xs: 90, sm: 108, md: 122, lg: 130 }}
              margin={{ xs: 30, sm: 54, md: 60, lg: 78 }}
              marginRightCn="mr-32 md:mr-72"
              containerMtCn="mt-40 md:mt-52"
            />
            <CompaniesRow
              companies={COMPANIES_ROW2}
              size={{ xs: 82, sm: 90, md: 112, lg: 120 }}
              margin={{ xs: 42, sm: 74, md: 72, lg: 92 }}
              marginRightCn="mr-24 md:mr-96"
              containerMtCn="mt-12 "
            />
            <CompaniesRow
              companies={COMPANIES_ROW3}
              size={{ xs: 72, sm: 76, md: 98, lg: 112 }}
              margin={{ xs: 40, sm: 80, md: 80, lg: 98 }}
              marginRightCn="mr-20 md:mr-104"
              containerMtCn="mt-12"
            />
          </Col>
        </Row>
      </Container>
      <BottomOpacity className="w-full absolute left-0 right-0 bottom-0" />
    </StyledSection>
  );
};

export default Companies;
